export default {
    'en': 'English',
    'pl': 'Polski',
    'ru': 'Русский',
    'RULES': 'Правила игры',
    "WORTH": "Стоимость главного приза 2500 евро.",
    "WIN": "Выиграйте",
    "JUSTFIT": "Justfit",
    "ME": "Me",
    "HERO_DESC": "Выиграйте первую систему EMS, которую вы можете использовать в любое время, в любом месте!",
    "SEARCH_JUSTFIT": 'Стенд Justfit: Зал IV. стенд 4.20',
    "ATTENDANCE": "Как можно принять участие в игре:",
    "LIST_1": "Найдите стенд Justfit на FIWE: Зал IV. стенд 4.20",
    "LIST_2": "Сделайте селфи перед фотостеной <span class='c-justfit-yellow font-weight-semibold'>#winjustfitme</span>",
    "LIST_3": "Загрузите фотографию в Фейсбук или в Инстаграм с хэштегом <span class='c-justfit-yellow font-weight-semibold'>#winjustfitme</span>. Срок подачи заявок: 15 сентября 2019 года, до полуночи.",
    "SUIT_HEADING": "1 система EMS JustfitMe по цене 2.500 евро",
    "PRIZE": "главный приз:",
    "LIST2_1": "Костюм гибридной технологии Unisex JustfitMe – выберите фасон, который вам нравится больше всего",
    "LIST2_2": "Блок управления JustfitMe",
    "LIST2_3": "Мобильное приложение JustfitMe",
    "SECOND_TEXT": "Выиграйте первую систему EMS (электростимуляция мышц), которую можно использовать в любом месте, в любое время без ограничений. Благодаря эффективной технологии электростимуляции, вам достаточно 2x20 минут тренировки в неделю, чтобы остаться в форме. И это выглядит очень, очень круто.",
    "SECOND_TEXT_2": "Дополнительные призы: 3 фирменные футболки Justfit.",
    "SECOND_TEXT_3": "Имена победителей будут опубликованы на наших страницах Фейсбук и в Инстаграм, кроме того, победители будут уведомлены в персональном сообщении до 22.09.2019. Подумайте о будущем, примите участие в игре сегодня!",
    "AMAZING_HASHTAG": "#winjustfitme",
}
